import React from 'react';
import { AccountNarrativeResponse } from './types';

interface Props {
  data: AccountNarrativeResponse;
  compact?: boolean;
}

const AccountNarrativeView: React.FC<Props> = ({ data, compact = false }) => {
  const ListSection = ({ title, items }: { title: string; items: string[] }) =>
    items?.length ? (
      <div className="border border-border rounded-lg p-4 bg-card">
        <h3 className="font-semibold mb-2">{title}</h3>
        <ul className="list-disc list-inside space-y-1 text-sm">
          {items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    ) : null;

  return (
    <div className="space-y-6">
      <div className="bg-indigo-50 dark:bg-indigo-900/20 p-6 rounded-lg">
        <h2 className="text-2xl font-bold mb-2">Value Narrative — {data.customer_name}</h2>
        <p className="text-sm text-muted-foreground">{data.start_date} to {data.end_date}</p>
        <div className={`mt-4 text-foreground whitespace-pre-wrap ${compact ? 'line-clamp-6' : ''}`}>
          {data.narrative}
        </div>
      </div>

      {!compact && (
        <>
          <ListSection title="Value Delivered" items={data.value_delivered || []} />
          <ListSection title="What's Changed" items={data.whats_changed || []} />
          <ListSection title="Recommended Next Steps" items={data.recommended_next || []} />
          <ListSection title="Evidence" items={data.evidence || []} />
        </>
      )}

      {data.generated_at && (
        <p className="text-xs text-muted-foreground">
          Generated {new Date(data.generated_at).toLocaleString()}
        </p>
      )}
    </div>
  );
};

export default AccountNarrativeView;
